const fs = require('fs')
import m from 'mithril';
import {trans, has_permission} from "../helpers";

import Steps from './steps.js';
import Typeahead from '../typeaheadComponent.js';
import SelectTypeahead from '../selectTypeaheadComponent.js';

const faThrash = fs.readFileSync('css/icons/thrash.svg', 'utf-8');

let challenge_state = require('../new_challenge_creator/challengeState.js');


window.state = challenge_state;


function get_roles() {
    if (challenge_state.roles.length == 0) {
        m.request('/api/roles?order_by=title|asc').then(d => {
            challenge_state.roles = d;

            if (challenge_state.roles.length > 0)
                challenge_state.new_role_id = challenge_state.roles[0].id_role;

        }).catch(err => {
            alert('Something went wrong, please refresh page.')
        })
    }
}

function get_visibility() {
    if (challenge_state.challenge.public*1 == 1)
        return 0;

    if (challenge_state.challenge.public*1 == 0 && challenge_state.challenge.unlisted*1 == 0)
        return 1;

     if (challenge_state.challenge.public*1 == 0 && challenge_state.challenge.unlisted*1 == 1)
        return 2;
}

function set_visibility(visibility) {
    if (visibility == 0) {
        challenge_state.challenge.public = 1;
        challenge_state.challenge.unlisted = 0;
    }
    if (visibility == 1) {
        challenge_state.challenge.public = 0;
        challenge_state.challenge.unlisted = 0;
    }
    if (visibility == 2) {
        challenge_state.challenge.public = 0;
        challenge_state.challenge.unlisted = 1;
    }
}

class OrganizationsSelector {
    getOrganizationsData(query, data_state, onDataLoaded, ctx) {
        m.request({
            method: "GET",
            url: "/api/organizations?order_by=long_title|asc&query="+query,
        }).then(function(data) {
            data_state.results = data;

            // onDataLoaded(ctx);
            data_state.is_loading = false;
            m.redraw();
        });
    }

    getOrganizationTitle(org) {
        if (org.title && org.title != '')
            return org.title;

        return org.long_title;
    }

    onOrganizationSelected(org) {
        if (challenge_state.challenge.organizations.list.filter(o => o.id_organization == org.id_organization).length > 0)
            return;

        challenge_state.challenge.organizations.list.push(org);
    }

    removeOrganization(org) {
        challenge_state.challenge.organizations.list = challenge_state.challenge.organizations.list.filter(o => o.id_organization != org.id_organization);
    }

    

    // challenges.canLimitToAnyOrganization
    
    view() {
        let selected_organizations_string = challenge_state.challenge.organizations.list.map(o => o.title).join(', ');

        return m('.organizations-selector', [
            // m('h2', trans('challenge.select_organizations')),
            // m('.ijf-form.typeahead-form', [
            m('.ijf-form', [
                m('.line.line--with-explainer', [
                    m('.line-element', [
                        m('label', [
                            trans('exercises.form.visibility'),
                        ]),
                        m('select', {
                            value: get_visibility(),
                            onchange: e => set_visibility(e.target.value*1)
                        }, [
                            m('option', {
                                value: 0,
                                selected: get_visibility() == 0
                            }, trans('common.public')),
                            m('option', {
                                value: 1,
                                selected: get_visibility() == 1
                            }, trans('common.private')),
                            m('option', {
                                value: 2,
                                selected: get_visibility() == 2
                            }, trans('common.unlisted'))
                        ])
                    ])
                ]),
                m('.line__explainer',
                    trans('challenge.visibility.' + get_visibility() + '.explainer')
                ),
                // m('.selected-exercises', [
                //     m('.selected-exercises__title', trans('challenge.challenge_will_be_seen_by.text') + ': '),
                    
                //     (challenge_state.challenge.organizations.list.length == 0) &&
                //     m('.selected-exercises__exercises', trans('challenge.challenge_will_be_seen_by.all').toUpperCase()),
                    
                //     (challenge_state.challenge.organizations.list.length > 0) &&
                //     m('.selected-exercises__exercises', selected_organizations_string),
                // ]),

                (get_visibility() != 1) &&
                m('.line', [
                    m('.line-element', [
                        m('label', [
                            trans('challenge.challenge_will_be_seen_by.text') + ': ',
                        ]),
                        !has_permission('challenges.canLimitToAnyOrganization') &&
                        m(SelectTypeahead, {
                            listMode: true,
                            list: challenge_state.available_organizations,
                            selectedItems: challenge_state.challenge.organizations, // must be object with 'list' atribute (see function: get_groups())
                            // placeholder: trans('challenge.select_organization_placeholder'),
                            placeholder: trans('challenge.challenge_will_be_seen_by.all').toUpperCase(),
                            dimPlaceholder: false,
                            noResultsText: trans('common.no_results'),
                            getItemText: this.getOrganizationTitle,
                            getItemId: o => o.id_organization
                        }),


                        has_permission('challenges.canLimitToAnyOrganization') &&
                        m(SelectTypeahead, {
                            listMode: false,
                            getData: this.getOrganizationsData,
                            selectedItems: challenge_state.challenge.organizations, // must be object with 'list' atribute (see function: get_groups())
                            // placeholder: trans('challenge.select_organization_placeholder'),
                            placeholder: trans('challenge.challenge_will_be_seen_by.all').toUpperCase(),
                            dimPlaceholder: false,
                            noResultsText: trans('common.no_results'),
                            getItemText: this.getOrganizationTitle,
                            getItemId: o => o.id_organization
                        })
                    ]),
                ]),
            ]),
        ])
    }
}

class RolesSelector {
    add_role(e) {
        // let role = challenge_state.roles.filter(r => r.id_role == challenge_state.new_role_id);
        let role = challenge_state.roles.filter(r => r.id_role == e.target.value*1);

        if (role.length == 0)
            return;

        role = role[0];

        if (challenge_state.challenge.roles.filter(r => r.id_role == role.id_role).length > 0)
            return;

        // role.regions_constraints = [];
        // role.sports_constraints = [];
        // role.organizations_constraints = [];

        role.regions_constraints = { list: [] };
        role.sports_constraints = { list: [] };
        role.organizations_constraints = { list: [] };

        challenge_state.challenge.roles.push(role);
    }

    remove_role(role) {
        challenge_state.challenge.roles = challenge_state.challenge.roles.filter(r => r.id_role != role.id_role);
    }

    view() {
        let selected_roles_ids = challenge_state.challenge.roles.map(r => r.id_role*1);
        let available_roles = challenge_state.roles.filter(r => has_permission('challenges.canInsertRole.'+r.code) && !selected_roles_ids.includes(r.id_role*1) );

        let selected_roles_string = challenge_state.challenge.roles.map(r => r.title).join(', ');

        return m('.roles-selector', [
            m('h2', trans('challenge.select_roles')),

            m('.selected-exercises', [
                m('.selected-exercises__title', trans('challenge.roles_that_can_insert_entries.text') + ': '),
                
                (challenge_state.challenge.roles.length == 0) &&
                m('.selected-exercises__exercises', trans('challenge.roles_that_can_insert_entries.all').toUpperCase()),
                
                (challenge_state.challenge.roles.length > 0) &&
                m('.selected-exercises__exercises', selected_roles_string),
            ]),
            
            challenge_state.challenge.roles.map(role => {
                return m('.role-container', [
                    m('.role-container__title', role.title) ,
                    m('.role-container__content', m(ConstraintSelector, {role: role})) ,
                    m('.role-container__remove', 
                        m('.pointer.icon', {
                            onclick: e => this.remove_role(role)
                        }, m.trust(faThrash))
                    )
                ])
            }),

            (available_roles.length > 0) &&
            m('.role-container', [
                m('.role-container__title', 
                    m('select', {
                        value: 0,
                        onchange: e => this.add_role(e)
                    }, [
                        m('option', {value: 0}, trans('challenge.select_role_text')),
                        available_roles.map(_r => {
                            return m('option', {
                                value: _r.id_role
                            }, _r.title)
                        })
                    ])
                ),
                // m('.role-container__content', m(ConstraintSelector, {role: role})) ,
                // m('.role-container__remove', 
                //     m('.pointer.icon', {
                //         onclick: e => this.remove_role(role)
                //     }, m.trust(faThrash))
                // )
            ])
            
            // m('.ijf-form', [
            //     m('.line', [
            //         m('.line-element', [
            //             m('select', {
            //                 value: 0,
            //                 onchange: e => this.add_role(e)
            //             }, [
            //                 m('option', {value: 0}, trans('challenge.select_role_text')),
            //                 available_roles.map(_r => {
            //                     return m('option', {
            //                         value: _r.id_role
            //                     }, _r.title)
            //                 })
            //             ])
            //         ])
            //         // m('.line-element', [
            //         //     m('.btn.btn--main', {
            //         //         onclick: e => this.add_role(e) 
            //         //     }, trans('challenge.add_role'))
            //         // ]),
            //     ]),
            // ]),

        ]);
    }
}

class ConstraintSelector {
    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&limit=40&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    onSportSelected(sport, params) {
        let role = params.role;

        if (role.sports_constraints.filter(s => s.id_sport == sport.id_sport).length > 0)
            return;

        role.sports_constraints.push(sport);
    }

    removeSport(role, sport) {
        role.sports_constraints = role.sports_constraints.filter(s => s.id_sport != sport.id_sport);
    }

    getSportTitle(sport) {
        // return Array((sport.depth*5)+1).join(`\u00A0`) + sport.title;
        return sport.title;
    }

    getRegionsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/regions?id_region_type=2&order_by=title|asc&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    onRegionSelected(reg, params) {
        let role = params.role;

        if (role.regions_constraints.filter(r => r.id_region == reg.id_region).length > 0)
            return;

        role.regions_constraints.push(reg);
    }

    removeRegion(role, region) {
        role.regions_constraints = role.regions_constraints.filter(r => r.id_region != region.id_region);
    }

    addOrganization(e, role) {
        let organization = challenge_state.challenge.organizations.list.filter(o => o.id_organization == e.target.value*1);

        if (organization.length == 0)
            return;

        organization = organization[0];

        if (role.organizations_constraints.filter(o => o.id_organization == organization.id_organization).length > 0)
            return;

        role.organizations_constraints.push(organization);
    }

    removeOrganization(role, organization) {
        role.organizations_constraints = role.organizations_constraints.filter(o => o.id_organization != organization.id_organization);
    }

    sports_constraints(role) {
        return m('.constraints-container', [
            m('.constraints-container__title', trans('challenge.constraints')+':'),
            m('.constraints-container__content', [
                // m('.constraints-container__content__constraints', [
                //     role.sports_constraints.length > 0 &&
                //     m('table.table.table--dark-theme.table--bordered.constraints-table', [
                //         m('tbody', [
                //              role.sports_constraints.map(sport => {
                //                 return m('tr', [
                //                     m('td', sport.title),
                //                     m('td', m('.pointer.icon', {
                //                         onclick: e => this.removeSport(role, sport)
                //                     }, m.trust(faThrash)))
                //                 ]);
                //             })
                //         ])
                //     ]),

                //     role.sports_constraints.length == 0 &&
                //     m('div', trans('challenge.no_constraints'))
                // ]),
                // m('.constraints-container__content__add-new', [
                m('.constraints-container__content__constraints', [
                    m('.ijf-form.typeahead-form', [
                        m('.line', [
                            m('.line-element', [
                                // m(Typeahead, { 
                                //     getData: this.getSportsData,
                                //     getItemText: this.getSportTitle,
                                //     onItemSelect: this.onSportSelected,
                                //     onItemSelectParams: {role: role},
                                //     placeholder: trans('challenge.select_sport_placeholder'),
                                //     noResultsText: trans('common.no_results')
                                // }),
                                m(SelectTypeahead, {
                                    listMode: false,
                                    getData: this.getSportsData,
                                    selectedItems: role.sports_constraints, // must be object with 'list' atribute (see function: get_groups())
                                    placeholder: trans('challenge.select_sport_placeholder'),
                                    noResultsText: trans('common.no_results'),
                                    getItemText: this.getSportTitle,
                                    getItemId: s => s.id_sport
                                })
                            ]),
                        ]),
                    ]),
                ]),
            ]),

        ]);
    }

    regions_constraints(role) {
        return m('.constraints-container', [
            m('.constraints-container__title', trans('challenge.constraints')+':'),
            m('.constraints-container__content', [
                // m('.constraints-container__content__constraints', [
                //     role.regions_constraints.length > 0 &&
                //     m('table.table.table--dark-theme.table--bordered.constraints-table', [
                //         m('tbody', [
                //              role.regions_constraints.map(region => {
                //                 return m('tr', [
                //                     m('td', region.title),
                //                     m('td', m('.pointer.icon', {
                //                         onclick: e => this.removeRegion(role, region)
                //                     }, m.trust(faThrash)))
                //                 ]);
                //             })
                //         ])
                //     ]),

                //     role.regions_constraints.length == 0 &&
                //     m('div', trans('challenge.no_constraints'))
                // ]),
                m('.constraints-container__content__constraints', [
                    m('.ijf-form.typeahead-form', [
                        m('.line', [
                            m('.line-element', [
                                // m(Typeahead, { 
                                //     getData: this.getRegionsData,
                                //     getItemText: reg => reg.title,
                                //     onItemSelect: this.onRegionSelected,
                                //     onItemSelectParams: {role: role},
                                //     placeholder: trans('challenge.select_region_placeholder'),
                                //     noResultsText: trans('common.no_results')
                                // }),
                                m(SelectTypeahead, {
                                    listMode: false,
                                    getData: this.getRegionsData,
                                    selectedItems: role.regions_constraints, // must be object with 'list' atribute (see function: get_groups())
                                    placeholder: trans('challenge.select_region_placeholder'),
                                    noResultsText: trans('common.no_results'),
                                    getItemText: reg => reg.title,
                                    getItemId: reg => reg.id_region
                                })
                            ]),
                        ]),
                    ]),
                ]),
            ]),

        ]);
    }

    organizations_constraints(role) {
        return m('.constraints-container', [
            m('.constraints-container__title', trans('challenge.constraints')+':'),
            m('.constraints-container__content', [
                m('.constraints-container__content__constraints', [
                    role.organizations_constraints.length > 0 &&
                    m('table.table.table--dark-theme.table--bordered.constraints-table', [
                        m('tbody', [
                             role.organizations_constraints.map(org => {
                                return m('tr', [
                                    m('td', org.title),
                                    m('td', m('.pointer.icon', {
                                        onclick: e => this.removeOrganization(role, org)
                                    }, m.trust(faThrash)))
                                ]);
                            })
                        ])
                    ]),

                    role.organizations_constraints.length == 0 &&
                    m('div', trans('challenge.no_constraints'))
                ]),
                m('.constraints-container__content__add-new', [
                    m('.ijf-form', [
                        m('.line', [
                            m('.line-element', [
                                m('select', {
                                    value: 0,
                                    onchange: e => this.addOrganization(e, role)
                                }, [
                                    m('option', {value: 0}, trans('challenge.select_organization_text')),
                                    challenge_state.challenge.organizations.list.map(_o => {
                                        return m('option', {
                                            value: _o.id_organization
                                        }, _o.title)
                                    })
                                ])
                            ])
                        ]),
                    ]),
                ]),
            ]),

        ]);
    }

    no_constraints(role) {
        return m('div', '');
    }

    view(vnode) {
        let role = vnode.attrs.role;

        if (role.needs_sport*1) {

            return this.sports_constraints(role);

        } else if(role.needs_region*1) {

            return this.regions_constraints(role);

        } 
        // else if(role.needs_organization*1) {

        //     return this.organizations_constraints(role);

        // }

        return this.no_constraints(role);
    }
}

class ChallengeVisibility {
    oninit() {
        get_roles();
        challenge_state.available_organizations.list = Object.values(SPORTNETXPAGE.USER_DATA.organizations);
    }

    go_back(e) {
        challenge_state.current_step = 'create_challenge';
    }

   
    save_challenge(e) {
        if (challenge_state.mode == 'insert') {
            let conf_box = confirm(trans('challenge.are_you_sure_finish_msg'));

            if (!conf_box)
                return;
        }

        // makes deep copy
        let challenge = JSON.parse(JSON.stringify(challenge_state.challenge));

        // let selected_exercises = challenge_state.exercises.filter(e => challenge_state.challenge.exercises.includes(e.id_exercise*1));
        // challenge.exercises = selected_exercises;

        let group_items = [];

        Object.keys(challenge_state.challenge.groups).map(group_code => {
            let group = challenge_state.challenge.groups[group_code];
            group.list.map(item => {
                group_items.push(item.id_group_item*1);
            });
        });

        challenge.group_items = group_items;
        delete challenge['groups'];

        delete challenge['data'];

        if (Object.keys(challenge_state.challenge.data).length > 0)
            challenge.variables =  challenge_state.challenge.data;

        challenge.organizations = challenge_state.challenge.organizations.list.map(org => org.id_organization*1);

        // IF DOES NOT HAVE PERMISSION TO CREATE PUBLIC NEEDS TO HAVE AT LEAST ONE ORGANIZATION (SILL CAN INSERT IF VISIBILITY SET TO PRIVATE)
        if (!has_permission('challenges.canCreatePublic') && challenge.organizations.length == 0 && get_visibility() != 1) {
            alert(trans('challenge.at_least_one_organization_required'));
            return;
        }
        
        let sports = challenge_state.challenge.sports.list.map(sc => sc.id_sport*1);
        challenge['sports'] = sports;

        let roles = challenge_state.challenge.roles.map(role => {
            let r = {
                id_role: role.id_role,
                sports_constraints: role.sports_constraints.list.map(sc => sc.id_sport*1),
                regions_constraints: role.regions_constraints.list.map(rc => rc.id_region*1),
                organizations_constraints: role.organizations_constraints.list.map(oc => oc.id_organization*1)
            }

            return r;
        });

        let has_private_exercise = false;

        if (challenge.public*1 == 1 ||challenge.unlisted*1 == 1) {
            challenge.exercises.forEach(exercise => {
                if (exercise.public*1 == 0 && exercise.unlisted*1 == 0) {
                    has_private_exercise = true;
                    return;
                }
            });
        }

        if (has_private_exercise) {
            let confirmed = confirm(trans('challenge.challenge_has_private_exercise_msg'));
            if (!confirmed) {
                return;
            }
        }

        challenge.roles = roles;

        challenge_state.current_step = 'saving_challenge';

        if (challenge_state.mode == 'update') {
            challenge.id_challenge = challenge_state.id_challenge;
        }

        m.request({
            method: "POST",
            url: "/api/challenge",
            responseType: "json",
            body: challenge
        }).then(d => {
            if (challenge_state.mode == 'insert') {
                challenge_state.id_challenge = d.id_challenge;
                challenge_state.challenge.id_challenge = d.id_challenge;
                challenge_state.challenge.slug = d.slug;
            }
            challenge_state.current_step = 'challenge_created';
        }).catch(e => {
            console.log(e)
            alert('Problem saving. try again')
        })
    }

    view() {
        return [
            m(Steps),
            m(OrganizationsSelector),

            (get_visibility() != 1) &&
            m(RolesSelector),

            m('.ijf-form', [
                m('.buttons-line', [
                    m('.btn', {
                        type: 'submit',
                        onclick: e => { this.go_back(e) }
                    }, trans('common.go_back')),

                    (challenge_state.mode == 'insert') &&
                    m('.btn.btn--full-width.btn--main', {
                        type: 'submit',
                        onclick: e => {
                            this.save_challenge(e);
                        }
                    }, trans('common.create_challenge')),

                    (challenge_state.mode == 'update') &&
                    m('.btn.btn--full-width.btn--main', {
                        type: 'submit',
                        onclick: e => {
                            this.save_challenge(e);
                        }
                    }, trans('common.save_changes'))
                ])
            ])
        ]
    }
}

export default ChallengeVisibility;